import { Component, OnInit } from '@angular/core';
// import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmedValidator } from 'src/app/shared/Validators/password-match'
import { CommonService } from '../services/common.service';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public barLabel: string = 'Password strength:';
  unamePattern = '^w+([.-]?w+)+@w+([.:]?w+)+(.[a-zA-Z0-9]{2,10})+$';
  newpassword
  name
  setPassForm
  submitted: boolean = false
  submitDone: boolean = false
  viewPass = false;
  viewConfPass = false;
  Form: FormGroup
  token
  type
  successMsg

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {
    if (localStorage.getItem('token') != null) {
      localStorage.clear();
      window.location.reload();
    }
    this.createForm();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.type = params.type;
    });
  }

  createForm() {
    this.Form = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirm: ['', [Validators.required]]
    }, {
      validator: ConfirmedValidator('password', 'confirm')
    });
  }

  submit() {
    this.submitted = true
    if (this.Form.invalid) {
      this.submitDone = true
    } else {
      this.submitDone = true
      let body = {
        password: this.f.password.value,
        token: this.token
      }
      this.commonService.changePassword(body).subscribe(res => {
        if (res.isValid) {
          this.successMsg = res.message
          this.Form.reset()
        }
      });
    }
  }

  get f() {
    return this.Form.controls
  }

  newpasswordFun(event) {
    this.newpassword = event
  }
}
